import _ from 'lodash'
import fp from 'lodash/fp'
import { getCellEventObject } from '@/common/utils/gnb.fp'
import { showBillingPopup, removeProperties } from '@/common/utils/common'
import { resizeThumbnail } from '@/common/utils/image'
import constant from '@/common/resources/constant'
import { parseUrl } from 'query-string'
import {
  CTA_ICON_AUTO_PLAY,
  CTA_ICON_INFORMATION,
  ON_CLICK_CELL,
  TOAST_TEXT,
} from '@/common/resources/const'
import cookie from '@/common/utils/cookie'

export default {
  props: {
    cellInfo: {
      type: Object,
    },
    thumbnailInfo: {
      type: Object,
    },
  },
  data() {
    return {
      isImageLoaded: false,
    }
  },
  methods: {
    goDetail(cellInfo) {
      const { onClick, onNavigation } = fp.flow(
        fp.get('event_list'),
        getCellEventObject,
      )(cellInfo)
      this.$events.$emit(ON_CLICK_CELL, onClick)
      const url = this.shaveUrl(_.get(onNavigation, 'url', ''))
      const { query } = parseUrl(url)
      let result = ''

      if (url.indexOf('purchasewebview') > -1) {
        const locationOrign =
          window.location.protocol + '//' + window.location.hostname
        showBillingPopup({
          productId: _.get(query, 'productId', ''),
          productType: 'all',
          returnUrl: constant.URL_PROTOCOL_WITH_DOMAIN,
          canceledUrl: locationOrign + '/callback.html?action=Cancel',
        })
      } else if (url.indexOf('member.') > -1) {
        window.open('https://' + url, '_blank')
      } else if (url.indexOf('notice_view') > -1) {
        result = url
      } else if (url.indexOf('theme-contents') > -1) {
        const themeId = _.get(query, 'themeid', '')
        result = `/list/EN${themeId}`
      } else if (url === '/voucher/index.html') {
        result = '/voucher/index'
      } else if (url === '/voucher/recommend.html') {
        result = '/voucher/recommend'
      } else {
        const cta = _.get(onNavigation, 'cta', '')
        result =
          cta === 'icon_autoplay'
            ? this.changeToStreamURL(
                url.replace('/index.html', '').replace('.html', ''),
              )
            : url.replace('/index.html', '').replace('.html', '')
      }
      if (result.indexOf('/player/vod') > -1 && result.indexOf('page') === -1) {
        result += '&page=1'
      }
      this.beforeRouterToDetail({
        onNavigation,
        fn: () => this.$router.push(result),
      })
    },
    beforeRouterToDetail({ onNavigation, fn }) {
      const toastText = _.get(onNavigation, TOAST_TEXT, '')
      if (toastText !== '') {
        this.$events.$emit('OPEN_PPV_TOAST', fn, toastText)
      } else {
        fn()
      }
    },
    getEventObject(cellInfo) {
      const { onClick, onNavigation, onDetail } = fp.flow(
        fp.get('event_list'),
        getCellEventObject,
      )(cellInfo)
      return { onClick, onNavigation, onDetail }
    },
    getURLFromEvent(eventObject) {
      return this.shaveUrl(_.get(eventObject, 'url', ''))
    },
    getCTAButtonFromEvent(eventObject) {
      return _.get(eventObject, 'cta', '')
    },
    // fixme: prepare to remove `goDetail()` method
    // goPurchaseWebView () {},
    // goMemberView () {},
    // goNoticeView () {},
    // goThemeContentsView () {},
    // goVoucherView () {},
    isOuterNavigationLink(onNavigation) {
      const {
        query: { external },
      } = parseUrl(onNavigation.url)
      return external === 'y'
    },
    externalUrl(onNavigation) {
      const {
        query: { url },
      } = parseUrl(onNavigation.url)
      return url
    },
    goNavigationView(cellInfo) {
      const { onClick, onNavigation } = this.getEventObject(cellInfo)
      const cta = this.getCTAButtonFromEvent(onNavigation)

      if (cta === CTA_ICON_AUTO_PLAY) return this.goStreamingView(cellInfo)
      this.sendClickEventLog(onClick)

      // NOTE: 25.09.22 전용관 밴드 신설에 따른 아웃링크 로직 추가
      // onNavigation 딥링크의 query에 external=y, url 존재에 따라 로직이 분기됨
      // - external=y: 새탭으로 url 오픈
      // - external=n or external 파라미터 미보유 / url 파라미터 보유 : 현재 탭으로 url 오픈
      // - external, url 파라미터 둘 다 미보유: 기존 로직과 동일하게 동작
      const originNavigationUrl = onNavigation.url
      const { url: navigaionUrl, query } = parseUrl(originNavigationUrl)
      const { external, url: externalUrl } = query

      const detailRouterInfo = {
        onNavigation,
        fn: () => this.moveToRouterPath(this.getURLFromEvent(onNavigation)),
      }

      if (external === 'y') {
        const cleanQuery = removeProperties(query, ['external', 'url'])
        const cleanNavigationUrl = `${navigaionUrl}?${new URLSearchParams(cleanQuery).toString()}`
        const targetUrl = decodeURIComponent(externalUrl || cleanNavigationUrl)
          .replace('http://', '')
          .replace('https://', '')

        detailRouterInfo.fn = () => {
          window.open(`https://${targetUrl}`, '_blank')
        }
      } else if (externalUrl) {
        const targetUrl = decodeURIComponent(externalUrl)
          .replace('http://', '')
          .replace('https://', '')

        detailRouterInfo.fn = () => {
          location.href = `https://${targetUrl}`
        }
      }

      this.beforeRouterToDetail(detailRouterInfo)
    },
    goStreamingView(cellInfo) {
      const { onClick, onNavigation } = this.getEventObject(cellInfo)
      const url = this.changeToStreamURL(this.getURLFromEvent(onNavigation))

      this.sendClickEventLog(onClick)
      this.moveToRouterPath(url)
    },
    goDetailView(cellInfo) {
      const { onClick, onDetail } = this.getEventObject(cellInfo)
      const cta = this.getCTAButtonFromEvent(onDetail)
      const url = this.getURLFromEvent(onDetail)

      if (cta !== CTA_ICON_INFORMATION) return this.goNavigationView(cellInfo)

      this.sendClickEventLog(onClick)
      this.moveToRouterPath(url)
    },
    sendClickEventLog(onClick) {
      this.$events.$emit(ON_CLICK_CELL, onClick)
    },
    moveToRouterPath(urlPath) {
      if (!urlPath) return
      this.$router.push(urlPath).catch(() => {})
    },
    shaveUrl(urlPath) {
      return urlPath
        .replace(constant.URL_DOMAIN, '')
        .replace(constant.URL_PROTOCOL_DEEP_LINK, '')
        .replace('www.wavve.com', '')
        .replace('http://', '')
        .replace('https://', '')
        .replace('/index.html', '')
        .replace('.html', '')
    },
    changeToStreamURL(urlPath) {
      return urlPath.replace('player/', 'player/stream/')
    },
    getLazyLoadingImageObject() {
      let thumbnail = _.get(this.cellInfo, 'thumbnail', '')
      if (thumbnail === '') {
        thumbnail = this.thumbnailInfo.placeholderImage
      }
      const isCircle =
        _.get(this.thumbnailInfo, 'componentName', '') === 'circle-cell'

      return resizeThumbnail(thumbnail, {
        width: this.thumbnailInfo.width,
        height: this.thumbnailInfo.height,
        isCircle,
        option: isCircle ? '10' : '20',
      })
    },
    getThumbnailImg() {
      return resizeThumbnail(_.get(this.cellInfo, 'thumbnail', ''), {
        width: this.thumbnailInfo.width,
        height: this.thumbnailInfo.height,
      })
    },
    onImageLoad() {
      this.isImageLoaded = true
    },
  },
  computed: {
    topTagList() {
      return _.get(this.cellInfo, 'top_taglist', []).concat(
        _.get(this.cellInfo, 'bottom_taglist', []),
      )
    },
    ageTag() {
      return _.get(this.cellInfo, 'age_tag', '')
    },
    adultDimClass() {
      const eventListUrl = _.get(this.cellInfo, 'event_list.1.url', '')
      this.type = eventListUrl.indexOf('player/movie') > -1 ? 'movie' : 'vod'
      const isDim =
        (!cookie.hasCredential() || cookie.isNotVerifiedAdultUser()) &&
        _.get(this.cellInfo, 'age', 0) >= 21
      if (isDim) {
        return this.type === 'vod' ? 'vod-lock-21' : 'movie-lock-21'
      } else {
        return ''
      }
    },
    targetAge() {
      return Number(_.get(this.cellInfo, 'age', 0))
    },
    isAdultContent() {
      return this.targetAge > 20
    },
    progress() {
      return _.get(this.cellInfo, 'progress', '')
    },
    hasProgress() {
      return this.progress !== ''
    },
    rank() {
      return _.get(this.cellInfo, 'rank', '')
    },
    hasRank() {
      return this.rank !== ''
    },
    titleList() {
      return _.get(this.cellInfo, 'title_list', [])
    },
    isThumbnail() {
      return _.get(this.cellInfo, 'thumbnail', '') !== ''
    },
    isPlayCta() {
      return _.get(this.cellInfo, 'cta', '') === 'icon_autoplay'
    },
    alt() {
      return _.get(this.cellInfo, 'alt', '')
    },
    altTitle() {
      return (
        this.cellInfo?.alt ??
        this.cellInfo?.title_list
          .map((el) => el?.text)
          .join(' ')
          .trim()
      )
    },
    brandTagList() {
      return _.get(this.cellInfo, 'brand_taglist', [])
    },
    updateTagList() {
      return _.get(this.cellInfo, 'brand_taglist', [])
    },
    subTitleClass() {
      let className = 'sub-title'
      return this.titleList.length === 0
        ? `${className} a11y-hidden`
        : className
    },
    displayCss() {
      if (this.isImageLoaded && this.isThumbnail) {
        return 'none'
      } else {
        return 'flex'
      }
    },
  },
}
